export enum SalaryDeviationType {
  Absence,
  WorkingHours,
  Compensation,
  TimeBalances,
}

export enum SalaryDeviationReportType {
  FullDay,
  Time,
  // Percentage, TODO: Add percentage input later
}

export enum NetOrBenefitIndicatorType {
  Net,
  Benefit,
}

export enum ChangeGrossSalaryTaxType {
  TableTax,
  OneTimeTax,
}

// Mirror the API client's enum names (Net/Gross, ExtraSalary/SalaryAdvance) and values, so the
// payload cast at the service-hook boundary is just a nominal-type bridge — no runtime rename.
// We don't re-export the API client's enum directly because the `export const = ns.Enum` pattern
// breaks at runtime under Vite/esbuild (ns property reads as undefined inside a namespace import).
export enum EarlyPayoutAmountType {
  Net,
  Gross,
}

export enum EarlyPayoutKind {
  ExtraSalary,
  SalaryAdvance,
}
